import "./src/styles/global.css";

import {
  initializeGoogleTag,
  trackGooglePageView,
} from "./src/utils/google-tag";
import {
  initializeSignupAttribution,
  syncSignupAttribution,
} from "./src/utils/signup-attribution";

export const onInitialClientRender = () => {
  initializeGoogleTag();
  initializeSignupAttribution();
  trackGooglePageView(window.location);
};

export const onRouteUpdate = ({ location }) => {
  syncSignupAttribution(location);
  trackGooglePageView(location);
};
